import React from "react";
import "./Masonry.scss";

const MasonryLayout = ({ children }) => (
  <div className="masonryLayout">{children}</div>
);
const MasonryItem = ({ children }) => (
  <div className="masonryItem">{children}</div>
);

export { MasonryLayout, MasonryItem };
